(function () {
  const MOBILE_BREAKPOINT = 850;

  const chevronSVG = `
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.58455 0L4.85871 3.71326L1.14545 0L0 1.14545L4.85871 6.01674L9.73 1.14545L8.58455 0Z" fill="white"/>
    </svg>`;

  function initFooterAccordion() {
    const menus = document.querySelectorAll('.footer-content .menu .menu__details');

    menus.forEach((details) => {
      const heading = details.querySelector('.menu__heading');
      if (!heading) return;

      // Chevron toevoegen (eenmalig)
      if (!heading.querySelector('.menu__heading__toggle--custom')) {
        const toggle = document.createElement('span');
        toggle.className = 'menu__heading__toggle--custom';
        toggle.innerHTML = chevronSVG;
        heading.appendChild(toggle);
      }

      // Begin ingeklapt op mobiel, open op desktop
      syncOpenState(details);
    });

    // Klik op de kop schakelt open/dicht — alleen op mobiel
    menus.forEach((details) => {
      const heading = details.querySelector('.menu__heading');
      heading.addEventListener('click', (e) => {
        if (window.innerWidth > MOBILE_BREAKPOINT) return;
        e.preventDefault(); // voorkom de native details-toggle, we doen het zelf
        details.open = !details.open;
      });
    });

    // Bij resize de juiste staat herstellen
    window.addEventListener('resize', () => {
      menus.forEach(syncOpenState);
    });
  }

  function syncOpenState(details) {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      details.open = true; // desktop: altijd open tonen
    } else {
      details.open = false; // mobiel: ingeklapt starten
    }
  }

  if (document.readyState !== 'loading') {
    initFooterAccordion();
  } else {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  }
})();